import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const LocationMarkerIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 20 20",
  path: (
    <>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.1665 11.9053C2.6237 12.5859 1.6665 13.5343 1.6665 14.5833C1.6665 16.6544 5.39746 18.3333 9.99984 18.3333C14.6022 18.3333 18.3332 16.6544 18.3332 14.5833C18.3332 13.5343 17.376 12.5859 15.8332 11.9053M14.9998 6.66663C14.9998 10.053 11.2498 11.6666 9.99984 14.1666C8.74984 11.6666 4.99984 10.053 4.99984 6.66663C4.99984 3.9052 7.23841 1.66663 9.99984 1.66663C12.7613 1.66663 14.9998 3.9052 14.9998 6.66663ZM10.8332 6.66663C10.8332 7.12686 10.4601 7.49996 9.99984 7.49996C9.5396 7.49996 9.1665 7.12686 9.1665 6.66663C9.1665 6.20639 9.5396 5.83329 9.99984 5.83329C10.4601 5.83329 10.8332 6.20639 10.8332 6.66663Z"
      />
    </>
  ),
});

LocationMarkerIcon.displayName = "LocationMarkerIcon";
export { LocationMarkerIcon };
